import React, { useEffect, useState } from "react";
import "../../../assets/AdminCss/admin_roles.css";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import { Link, useNavigate } from "react-router-dom";
import { base_url } from "./AdminUsers";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import ColorSettings from "../../components/ColorSettings";

const Slider = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [sliders, setSliders] = useState([]);
  const [logo, setLogo] = useState([]);
  const [modal, setModal] = useState([]);
  const [filteredSliders, setFilteredSliders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedSliders, setSelectedSliders] = useState([]);
  const [selectedSliders2, setSelectedSliders2] = useState([]);
  const [selectedSliders3, setSelectedSliders3] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteModal2, setShowDeleteModal2] = useState(false);
  const [showDeleteModal3, setShowDeleteModal3] = useState(false);
  const [sliderToDelete, setSliderToDelete] = useState(null);
  const [sliderToDelete2, setSliderToDelete2] = useState(null);
  const [sliderToDelete3, setSliderToDelete3] = useState(null);
  const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);

  // New state variables for search and pagination
  const [searchTerm, setSearchTerm] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [logoPath, setLogoPath] = useState('');
  const [modalPath, setModalPath] = useState('');

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const fetchSliders = async () => {
    const auth = localStorage.getItem("admin");
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${base_url}/api/webapi/fetchBannerAction`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      if (response.data.success) {
        setSliders(response.data.data.result);
        setFilteredSliders(response.data.data.result);
      } else {
        throw new Error("Failed to fetch sliders");
      }
    } catch (error) {
      console.error("Error fetching sliders:", error);
      setError("Failed to load sliders. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSliders();
  }, []);

  const showLogo = async () => {
    const auth = localStorage.getItem("admin");
    try {
      setLoading(true);
      const response = await axios.get(base_url + '/api/webapi/fetchLogoAction', {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${auth}`,
        },
      });

      const data = response.data.data.result[0];

      console.log("Fetched logo data:", data);

      if (data && data.logo_image) {
        setLogo(data);
        setLogoPath(data.logo_image);
      } else {
        throw new Error("Failed to fetch logo");
      }

    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    showLogo();
  }, []);


  const showModal = async () => {
    const auth = localStorage.getItem("admin");
    try {
      setLoading(true);
      const response = await axios.get(base_url + '/api/webapi/fetchModal', {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${auth}`,
        },
      });

      const data = response.data.data.result[0];

      console.log("Fetched logo data:", data);

      if (data && data.image) {
        setModal(data);
        setModalPath(data.image);
      } else {
        throw new Error("Failed to fetch logo");
      }

    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    showModal();
  }, []);

  // Apply search filter whenever searchTerm changes
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredSliders(sliders);
    } else {
      const filtered = sliders.filter(slider =>
        slider.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        slider.status.toLowerCase().includes(searchTerm.toLowerCase()) ||
        slider.type.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredSliders(filtered);
    }
    // Reset to first page when search changes
    setCurrentPage(1);
  }, [searchTerm, sliders]);

  // Handle individual checkbox selection
  const handleCheckboxChange = (sliderId) => {
    setSelectedSliders(prev => {
      if (prev.includes(sliderId)) {
        return prev.filter(id => id !== sliderId);
      } else {
        return [...prev, sliderId];
      }
    });
  };

  const handleCheckboxChange2 = (logoId) => {
    setSelectedSliders2(prev => {
      if (prev.includes(logoId)) {
        return prev.filter(id => id !== logoId);
      } else {
        return [...prev, logoId];
      }
    });
  };

  const handleCheckboxChange3 = (ModalId) => {
    setSelectedSliders3(prev => {
      if (prev.includes(ModalId)) {
        return prev.filter(id => id !== ModalId);
      } else {
        return [...prev, ModalId];
      }
    });
  };

  // Handle "select all" checkbox for the current page
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const currentPageIds = paginatedSliders.map(slider => slider.id);
      setSelectedSliders(prevSelected => {
        const nonPageIds = prevSelected.filter(id => !currentPageIds.includes(id));
        return [...nonPageIds, ...currentPageIds];
      });
    } else {
      const currentPageIds = paginatedSliders.map(slider => slider.id);
      setSelectedSliders(prevSelected =>
        prevSelected.filter(id => !currentPageIds.includes(id))
      );
    }
  };

  const handleSelectAll2 = (e) => {
    if (e.target.checked) {
      const currentPageIds = paginatedSliders.map(slider => slider.id);
      setSelectedSliders2(prevSelected => {
        const nonPageIds = prevSelected.filter(id => !currentPageIds.includes(id));
        return [...nonPageIds, ...currentPageIds];
      });
    } else {
      const currentPageIds = paginatedSliders.map(slider => slider.id);
      setSelectedSliders2(prevSelected =>
        prevSelected.filter(id => !currentPageIds.includes(id))
      );
    }
  };

  // Handle edit button click
  const handleEdit = (sliderId) => {
    navigate(`/admin/editSlider/${sliderId}`);
  };
  // Handle edit button click
  const handleEdit2 = (LogoId) => {
    const nav = navigate(`/admin/editLogo/${LogoId}`);
  };
  // Handle edit button click
  const handleEdit3 = (ModalId) => {
    const nav = navigate(`/admin/editModal/${ModalId}`);
  };

  // Handle delete button click
  const handleDeleteClick = (slider) => {
    setSliderToDelete(slider);
    setShowDeleteModal(true);
  };

  // Handle delete button click
  const handleDeleteClick2 = (logo) => {
    setSliderToDelete2(logo);
    setShowDeleteModal2(true);
  };

  // Handle delete button click
  const handleDeleteClick3 = (modal) => {
    setSliderToDelete3(modal);
    setShowDeleteModal3(true);
  };

  // Handle bulk delete button click
  const handleBulkDeleteClick = () => {
    if (selectedSliders.length > 0) {
      setShowBulkDeleteModal(true);
    } else {
      alert("Please select at least one slider to delete");
    }
  };

  // Handle bulk delete button click
  const handleBulkDeleteClick2 = () => {
    if (selectedSliders2.length > 0) {
      setShowBulkDeleteModal(true);
    } else {
      alert("Please select at least one slider to delete");
    }
  };

  // Confirm single slider deletion
  const confirmDelete = async () => {
    if (!sliderToDelete) return;

    const auth = localStorage.getItem("admin");
    try {
      const response = await axios.post(
        `${base_url}/api/webapi/deleteBannerAction`,
        { id: sliderToDelete.id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      if (response.data.success) {
        setSelectedSliders(prev => prev.filter(id => id !== sliderToDelete.id));
        fetchSliders();

      } else {
        alert("Failed to delete slider: " + response.data.message);
      }
    } catch (error) {
      console.error("Error deleting slider:", error);
      alert("An error occurred while deleting the slider. Please try again.");
    } finally {
      setShowDeleteModal(false);
      setSliderToDelete(null);
    }
  };


  const confirmDelete2 = async () => {
    if (!sliderToDelete2) return;

    const auth = localStorage.getItem("admin");
    try {
      const response = await axios.post(
        `${base_url}/api/webapi/deleteLogoAction`,
        { id: sliderToDelete2.id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      if (response.data.success) {
        setSelectedSliders2(prev => prev.filter(id => id !== sliderToDelete2.id));
      } else {
        alert("Failed to delete slider: " + response.data.message);
      }
    } catch (error) {
      console.error("Error deleting slider:", error);
      alert("An error occurred while deleting the slider. Please try again.");
    } finally {
      setShowDeleteModal2(false);
      setSliderToDelete2(null);
      showLogo();
    }
  };


  const confirmDelete3 = async () => {
    if (!sliderToDelete3) return;

    const auth = localStorage.getItem("admin");
    try {
      const response = await axios.post(
        `${base_url}/api/webapi/deleteModal`,
        { id: sliderToDelete3.id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      if (response.data.success) {
        setSelectedSliders3(prev => prev.filter(id => id !== sliderToDelete3.id));
      } else {
        alert("Failed to delete slider: " + response.data.message);
      }
    } catch (error) {
      console.error("Error deleting slider:", error);
      alert("An error occurred while deleting the slider. Please try again.");
    } finally {
      setShowDeleteModal3(false);
      setSliderToDelete3(null);
      showModal();
    }
  };


  const confirmBulkDelete = async () => {
    const auth = localStorage.getItem("admin");
    try {
      const response = await axios.post(
        `${base_url}/api/webapi/bulkDeleteBannerAction`,
        { ids: selectedSliders },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      if (response.data.success) {
        // Refresh the sliders list
        fetchSliders();
        setSelectedSliders([]);

      } else {
        alert("Failed to delete sliders: " + response.data.message);
      }
    } catch (error) {
      console.error("Error deleting sliders:", error);
      alert("An error occurred while deleting the sliders. Please try again.");
    } finally {
      setShowBulkDeleteModal(false);
    }
  };

  // Handle change in entries per page
  const handleEntriesPerPageChange = (e) => {
    setEntriesPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1); // Reset to first page when changing entries per page
  };

  // Calculate pagination
  const indexOfLastSlider = currentPage * entriesPerPage;
  const indexOfFirstSlider = indexOfLastSlider - entriesPerPage;
  const paginatedSliders = filteredSliders.slice(indexOfFirstSlider, indexOfLastSlider);
  const totalPages = Math.ceil(filteredSliders.length / entriesPerPage);

  // Check if current page sliders are all selected
  const areAllCurrentPageSelected =
    paginatedSliders.length > 0 &&
    paginatedSliders.every(slider => selectedSliders.includes(slider.id));

  const areAllCurrentPageSelected2 =
    paginatedSliders.length > 0 &&
    paginatedSliders.every(slider => selectedSliders.includes(slider.id));

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);

      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="">
      {/* Main Sidebar */}
      <AdminSidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />

      {/* Header - Pass mobile info */}
      <AdminHeader
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        isMobile={isMobile}
      />

      {/* Content Wrapper - Use conditional class and margin */}
      <div
        className={`content-wrapper d-flex flex-column ${!isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}                                                            
        style={{                                                               
          marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",                       
          transition: "margin-left 0.3s ease",                                         
        }}                                                                
      >                                                                                      
        <div className="container-fluid">
          <h1 className="page-title custom_pagetitle">
            <i className="sidebar-mini-lock"></i> Slider
          </h1>

          <button
            onClick={handleBulkDeleteClick}
            className="btn btn-danger btn-add-new red_btn"
            disabled={selectedSliders.length === 0}
          >
            <i className="fa fa-trash"></i> <span>Bulk Delete</span>
          </button>

          <div className="pull-right topright_buttons ">
            <Link
              to="/admin/addSlider"
              className="btn btn-success btn-add-new red_btn"
            >
              <i className="fa fa-plus"></i> <span>Add New</span>
            </Link>
          </div>
          <div id="sidebar-mini-notifications"></div>
          <div className="page-content mt-4 browse">
            <div className="alerts"></div>
            <div className="row">
              <div className="col-md-12 oneonofftab mb-0">
                <div className="panel panel-bordered p-3 mb-0">
                  <div className="panel-body">
                    <form>
                      <div className="d-flex justify-content-between mx-4">
                        <div className="d-flex align-items-center">
                          <label className="me-2">Show</label>
                          <select
                            className="form-select me-2"
                            style={{ width: 'auto' }}
                            value={entriesPerPage}
                            onChange={handleEntriesPerPageChange}
                          >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </select>
                          <label>entries</label>
                        </div>
                        <div className="d-flex align-items-center">
                          <label className="me-2">Search:</label>
                          <input
                            type='text'
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Search..."
                          />
                        </div>
                      </div>
                    </form>
                    <div className="mt-3">
                      {isLoading ? (
                        <p>Loading sliders...</p>
                      ) : error ? (
                        <p className="text-danger">{error}</p>
                      ) : (
                        <>
                          <table id="dataTable" className="table table-hover">
                            <thead>
                              <tr>
                                <th className="text-center">
                                  <input
                                    type='checkbox'
                                    name="all"
                                    onChange={handleSelectAll}
                                    checked={areAllCurrentPageSelected && paginatedSliders.length > 0}
                                  />
                                </th>
                                <th className="text-center">Title</th>
                                <th className="text-center">Status</th>
                                <th className="text-center">Type</th>
                                <th className="text-center">Image</th>
                                <th className="text-center">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {paginatedSliders.length > 0 ? (
                                paginatedSliders.map((slider) => (
                                  <tr key={slider.id}>
                                    <td className="text-center">
                                      <input
                                        type='checkbox'
                                        checked={selectedSliders.includes(slider.id)}
                                        onChange={() => handleCheckboxChange(slider.id)}
                                      />
                                    </td>
                                    <td>{slider.title}</td>
                                    <td>{slider.status}</td>
                                    <td>{slider.type}</td>
                                    <td>
                                      {slider.attachment && (
                                        <img
                                          src={`${base_url}${slider.attachment}`}
                                          alt={slider.title}
                                          style={{ maxWidth: '100px', maxHeight: '60px' }}
                                        />
                                      )}
                                    </td>
                                    <td className="d-flex gap-2 justify-content-end">
                                      <button
                                        className="btn btn-primary"
                                        onClick={() => handleEdit(slider.id)}
                                      >
                                        <i className="fa fa-edit"></i> Edit
                                      </button>
                                      <button
                                        className="btn btn-danger red_btn"
                                        onClick={() => handleDeleteClick(slider)}
                                      >
                                        <i className="fa fa-trash"></i> Delete
                                      </button>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="6" className="text-center">No sliders found</td>
                                </tr>
                              )}
                            </tbody>
                          </table>

                          {/* Pagination Controls */}
                          {filteredSliders.length > 0 && (
                            <div className="d-flex justify-content-between align-items-center mt-3">
                              <div>
                                Showing {indexOfFirstSlider + 1} to {Math.min(indexOfLastSlider, filteredSliders.length)} of {filteredSliders.length} entries
                              </div>
                              <div>
                                <button
                                  className="btn btn-secondary me-2"
                                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                  disabled={currentPage === 1}
                                >
                                  Previous
                                </button>
                                <button
                                  className="btn btn-secondary"
                                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                  disabled={currentPage === totalPages}
                                >
                                  Next
                                </button>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>





      {/* Content Wrapper - Use conditional class and margin */}
      {/* <div
        className={`content-wrapper d-flex flex-column ${!isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
        style={{
          marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
          transition: "margin-left 0.3s ease"
        }}
      >
        <div className="container-fluid">
          <h1 className="page-title custom_pagetitle">
            <i className="sidebar-mini-lock"></i> Logo
          </h1>

         
          <div className="pull-right topright_buttons ">
            <Link
              to="/admin/addSlider"
              className="btn btn-success btn-add-new red_btn"
            >
              <i className="fa fa-plus"></i> <span>Add New</span>
            </Link>
          </div>
          <div id="sidebar-mini-notifications"></div>
          <div className="page-content mt-4 browse">
            <div className="alerts"></div>
            <div className="row">
              <div className="col-md-12 oneonofftab">
                <div className="panel panel-bordered p-3">
                  <div className="panel-body">
                    <form>
                      <div className="d-flex justify-content-between mx-4">
                        <div className="d-flex align-items-center">
                          <label className="me-2">Show</label>
                          <select
                            className="form-select me-2"
                            style={{ width: 'auto' }}
                            value={entriesPerPage}
                            onChange={handleEntriesPerPageChange}
                          >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </select>
                          <label>entries</label>
                        </div>
                        <div className="d-flex align-items-center">
                          <label className="me-2">Search:</label>
                          <input
                            type='text'
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Search..."
                          />
                        </div>
                      </div>
                    </form>
                    <div className="mt-3">
                      {isLoading ? (
                        <p>Loading Logo...</p>
                      ) : error ? (
                        <p className="text-danger">{error}</p>
                      ) : (
                        <>
                          <table id="dataTable" className="table table-hover">
                            <thead>
                              <tr>
                                <th className="text-center">
                                 
                                </th>
                                <th className="text-center">Image</th>
                                <th className="text-center">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {logoPath ? (
                                <tr>
                                  <td className="text-center">
                                    <input
                                      type='checkbox'
                                      checked={selectedSliders2.includes(logo.id)}
                                      onChange={() => handleCheckboxChange2(logo.id)}
                                    />
                                  </td>
                                  <td className="text-center">
                                    <img
                                      className="img-fluid"
                                      style={{ width: "170px", height: "60px", paddingLeft: "9px" }}
                                      src={`${base_url}${logoPath}`}
                                      alt="Logo_Kheloyaar360"
                                    />
                                  </td>
                                  <td className="d-flex gap-2 justify-content-end">
                                    <button
                                      className="btn btn-primary"
                                      onClick={() => handleEdit2(logo.id)} 
                                    >
                                      <i className="fa fa-edit"></i> Edit
                                    </button>
                                    <button
                                      className="btn btn-danger red_btn"
                                      onClick={() => handleDeleteClick2(logo)}
                                    >
                                      <i className="fa fa-trash"></i> Delete
                                    </button>
                                  </td>
                                </tr>
                              ) : (
                                <tr>
                                  <td colSpan="3" className="text-center">No logo found</td>
                                </tr>
                              )}
                            </tbody>

                          </table>

            
                          {filteredSliders.length > 0 && (
                            <div className="d-flex justify-content-between align-items-center mt-3">
                              <div>
                                Showing {indexOfFirstSlider + 1} to {Math.min(indexOfLastSlider, filteredSliders.length)} of {filteredSliders.length} entries
                              </div>
                              <div>
                                <button
                                  className="btn btn-secondary me-2"
                                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                  disabled={currentPage === 1}
                                >
                                  Previous
                                </button>
                                <button
                                  className="btn btn-secondary"
                                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                  disabled={currentPage === totalPages}
                                >
                                  Next
                                </button>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}





      {/* Content Wrapper - Use conditional class and margin */}
      <div
        className={`content-wrapper d-flex flex-column ${!isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
        style={{
          marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
          transition: "margin-left 0.3s ease"
        }}
      >
        <div className="container-fluid">
          <h1 className="page-title custom_pagetitle">
            <i className="sidebar-mini-lock"></i>Modal Login
          </h1>

          {/* <button
            onClick={handleBulkDeleteClick2}
            className="btn btn-danger btn-add-new red_btn"
            disabled={selectedSliders.length === 0}
          >
            <i className="fa fa-trash"></i> <span>Bulk Delete</span>
          </button> */}

          <div className="pull-right topright_buttons ">
            <Link
              to="/admin/addSlider"
              className="btn btn-success btn-add-new red_btn"
            >
              <i className="fa fa-plus"></i> <span>Add New</span>
            </Link>
          </div>
          <div id="sidebar-mini-notifications"></div>
          <div className="page-content mt-4 browse">
            <div className="alerts"></div>
            <div className="row">
              <div className="col-md-12 oneonofftab">
                <div className="panel panel-bordered p-3">
                  <div className="panel-body">
                    <form>
                      <div className="d-flex justify-content-between mx-4">
                        <div className="d-flex align-items-center">
                          <label className="me-2">Show</label>
                          <select
                            className="form-select me-2"
                            style={{ width: 'auto' }}
                            value={entriesPerPage}
                            onChange={handleEntriesPerPageChange}
                          >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </select>
                          <label>entries</label>
                        </div>
                        <div className="d-flex align-items-center">
                          <label className="me-2">Search:</label>
                          <input
                            type='text'
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Search..."
                          />
                        </div>
                      </div>
                    </form>
                    <div className="mt-3">
                      {isLoading ? (
                        <p>Loading ModalLogin...</p>
                      ) : error ? (
                        <p className="text-danger">{error}</p>
                      ) : (
                        <>
                          <table id="dataTable" className="table table-hover">
                            <thead>
                              <tr>
                                <th className="text-center">
                                  {/* <input
                                    type='checkbox'
                                    name="all"
                                    onChange={handleSelectAll2}
                                    checked={areAllCurrentPageSelected2 && paginatedSliders.length > 0}
                                  /> */}
                                </th>
                                <th className="text-center">Image</th>
                                <th className="text-center">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {modalPath ? (
                                <tr>
                                  <td className="text-center">
                                    <input
                                      type='checkbox'
                                      checked={selectedSliders3.includes(modal.id)}
                                      onChange={() => handleCheckboxChange3(modal.id)}
                                    />
                                  </td>
                                  <td className="text-center">
                                    <img
                                      className="img-fluid"
                                      style={{ width: "170px", height: "60px", paddingLeft: "9px" }}
                                      src={`${base_url}${modalPath}`}
                                      alt="Logo_Kheloyaar360"
                                    />
                                  </td>
                                  <td className="d-flex gap-2 justify-content-end">
                                    <button
                                      className="btn btn-primary"
                                      onClick={() => handleEdit3(modal.id)} // Now modal.id is correct
                                    >
                                      <i className="fa fa-edit"></i> Edit
                                    </button>
                                    <button
                                      className="btn btn-danger red_btn"
                                      onClick={() => handleDeleteClick3(modal)}
                                    >
                                      <i className="fa fa-trash"></i> Delete
                                    </button>
                                  </td>
                                </tr>
                              ) : (
                                <tr>
                                  <td colSpan="3" className="text-center">No logo found</td>
                                </tr>
                              )}
                            </tbody>

                          </table>

                          {/* Pagination Controls */}
                          {filteredSliders.length > 0 && (
                            <div className="d-flex justify-content-between align-items-center mt-3">
                              <div>
                                Showing {indexOfFirstSlider + 1} to {Math.min(indexOfLastSlider, filteredSliders.length)} of {filteredSliders.length} entries
                              </div>
                              <div>
                                <button
                                  className="btn btn-secondary me-2"
                                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                  disabled={currentPage === 1}
                                >
                                  Previous
                                </button>
                                <button
                                  className="btn btn-secondary"
                                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                  disabled={currentPage === totalPages}
                                >
                                  Next
                                </button>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{marginLeft:"250px"}}>
        {/* <ColorSettings /> */}
      </div>


      {/* Single Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the slider "{sliderToDelete?.title}"?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>


      {/* Single Delete Confirmation Modal */}
      <Modal show={showDeleteModal2} onHide={() => setShowDeleteModal2(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the slider "{sliderToDelete2?.title}"?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal2(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete2}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>


      {/* Single Delete Confirmation Modal */}
      <Modal show={showDeleteModal3} onHide={() => setShowDeleteModal3(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the slider "{sliderToDelete3?.title}"?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal3(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete3}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Bulk Delete Confirmation Modal */}
      <Modal show={showBulkDeleteModal} onHide={() => setShowBulkDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Bulk Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete {selectedSliders.length} selected slider(s)?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowBulkDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmBulkDelete}>
            Delete All Selected
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Slider;